import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMuiSelectOption } from "../components/framework/muiAutocomplete2";
import { getVehicles } from "../services/vehicleService";
import { VehicleListItemDto } from "../models/transport/vehicle";

export interface VehicleState {
    vehicles: VehicleListItemDto[];
    options: IMuiSelectOption[];
}

export const initialState: VehicleState = {
    vehicles: null,
    options: null,
};

export const vehicleSlice = createSlice({
    name: "vehicle",
    initialState,
    reducers: {
        setVehicles: (state, action: PayloadAction<VehicleListItemDto[]>) => {
            state.vehicles = action.payload;
        },
        setOptions: (state, action: PayloadAction<IMuiSelectOption[]>) => {
            state.options = action.payload;
        },
    },
});

export const { setVehicles, setOptions } = vehicleSlice.actions;

export const fetchVehicleOptions = createAsyncThunk(
    "vehicle/options",
    async(_, thunkApi) => {
        const vehicles = await getVehicles(false, thunkApi.signal);
        thunkApi.dispatch(setVehicles(vehicles.data));
        thunkApi.dispatch(
            setOptions(
                vehicles.data.map((v) => ({
                    value: v.id,
                    label: `${v.registerNumber}, ${v.brand}`,
                }))
            )
        );
    }
);

export const vehicleReducer = vehicleSlice.reducer;
